// TODO: do NOT export unused interfaces

import { TNestedGenericId } from '@microfrontends/react-components'
import { MultiLevelSelectParams } from '@microfrontends/react-components/components/MultiLevelSelect'

export interface IProfileData {
    summary: ISummaryResponse
    contactInfo: TContactInfoResponse
    // skills: Skills
    skills: TSkillRawData

    // languages: Languages
    languages: TLanguageRawData

    activities: IActivityData
    workingHistories: IProfileSuccessCollectionResponse<IWorkingHistoryResource>
    educations: TEducationsResponse
    references: IProfileSuccessCollectionResponse<IReferenceResource>
    workingPreferences: IWorkingPreferencesRawData
    certifications: IProfileSuccessCollectionResponse<ICertificationResource>
    recommendations: IProfileSuccessCollectionResponse<IRecommendationResource>
    basicInfo: TBasicInfoRawData
}

export type TContactInfoResponse = {
    data: TContactInfoRawData
}

export type TContactInfoRawData = {
    type: string
    id: number
    attributes: {
        email: string
        phone: string
        birthday: Date
        genderId: number
        countryId: number
        cityId: number
        address: string
        nationalityId: number
        maritalStatusId: number
        districtId: number
        isSearchable: number
    }
}

/**
 * Education Types
 */
export type TEducationsResponse = {
    data: TEducationsItemRawData[]
}

export type TEducationsItemRawData = {
    type: string
    id: number
    attributes: {
        highestDegreeId: number
        schoolId: number
        schoolName: string
        major: string
        countryId: number
        description: string
        educationOrder: number
        startDate: string
        endDate: string
    }
}

export type TEducationItemData = {
    id: number
    highestDegreeId: number
    schoolId: number
    schoolName: string
    major: string
    countryId: number
    description: string
    educationOrder: number
    startDate: Date | null
    endDate: Date | null
    isNewEducation?: boolean
}

export type TProjectItemRawData = {
    type: string
    id: any
    attributes: {
        name: string
        role: string
        organization: string
        link: string
        fromDate:  Date | null
        toDate:  Date | null
        description: string
        imageUrl: string
        companyId: any
        companyLogo?: string
    }
}

export type TProjectItemData = {
    id: any
    userProjectId?: string
    name: string
    organization: any
    role: string
    startDate?: Date | null
    endDate?: Date | null
    link?: string
    description: string
    skill?: string
    companyId?: any
    companyLogo?: string
}

export interface ISummaryResponse {
    data: {
        type: string
        id: number
        attributes: ISummary
    }
}

export interface IProfileSuccessSingleResponse<T> {
    data: {
        id: number
        type: string
        attributes: T
    }
}

export interface IProfileSuccessCollectionResponse<T> {
    data: {
        id: number
        type: string
        attributes: T
    }[]
}

// TODO - [refactor] Replace interface with type for consistency with WOW-CV projects
export interface IUpdateCommonResponse<T = any> {
    data?: T
    meta?: {
        message: string
        code: number
    }
    error?: string | boolean | any
    errorCode?: string
}

export interface IUpdateRawResponse {
    data?: any
    meta?: {
        message: string
        code: number
    }
    message?: string
    showMessage?: boolean
    errorCode?: string
}

export interface IUpdateCommon<T> {
    error: boolean | string
    data: T | null
}

export interface IUpdatedSummaryResponse {
    data: {
        id: number
    }
}

export interface ISummary {
    summary: string
    resumeId: number
}

export interface IUpdatedSummary {
    id: number
}

export interface IWorkingHistoryResource {
    jobTitle: string
    jobLevelID: number
    jobLevelId: number
    companyLogo: string
    companyName: string
    countryID: number
    cityID: number
    industryID: number
    description: string
    experienceOrder: number
    isCurrent: boolean | number
    startDate: string | Date
    endDate: string | Date
    id: number
}

interface IWorkingPreferencesRawData {
    data: {
        type: string
        id: number
        attributes: TWorkingPreferencesData
    }
}
export type TLocation = { cityId: number; districtId: number }

export type TWorkingPreferencesData = {
    locations: TLocation[]
    industries: number[]
    companyIndustries: number[]
    isRelocate: boolean
    desiredJobLevelId: number
    salary: string
    benefits: number[] | null
    userId: number
    jobFunction: TNestedGenericId[]
    jobTitle?: string
}

export type TProfileInfo = {
    userId: number
    resumeId: number
    firstName: string
    lastName: string
    fullName: string
    highestDegreeId: number
    isDownload: boolean
    isOpenToWork: number
    jobTitle: string
    jobLevelId: number
    yearsExperience: number
    avatar: string
    lastCompany: string
    wowcvTemplateId: number
    currentIndustries: number[]
    currentJobFunction: TNestedGenericId[]
    currentSalary: number
}

type TUserContactInfo = {
    address: string
    nationalityId: number
    genderId: number
    cityId: number
    userId: number
    countryId: number
    maritalStatusId: number
    districtId: number
    resumeId: number
    phone: string
    isSearchable: boolean
    email: string
    levelLocations: MultiLevelSelectParams['value'][]
}
export type TUserContactInfoRawData = TUserContactInfo & { birthday: string }
export type TUserContactInfoData = TUserContactInfo & { birthday: Date | null }

export interface IReferenceResource {
    id: number
    name: string
    title: string
    companyName: string
    phone: string
    email: string
    description: string
    referenceType: number
    isAvailable: boolean
}

export interface IProfileInfoResource {
    resumeId: number
    userId: number
    firstName: string
    lastName: string
    jobTitle: string
    jobLevelId: number
    highestDegreeId: number
    yearsExperience: number
    email: string
    phone: string
    birthday: string
    genderId: number
    countryId: number
    cityId: number
    districtId: number
    address: string
    nationalityId: number
    avatar: string
    maritalStatusId: number
    isSearchable: number
    currentIndustries: number[]
    currentJobFunction: TNestedGenericId[]
    currentSalary: number
    levelLocations: MultiLevelSelectParams['value'][]
}

export interface IRecommendationResource {
    id: number
    userId: number
    fullName: string
    position: string
    company: string
    linkedIn: string
    email: string
    phone: string
    coverLetter: string
    status: number
    IsShown: boolean
    entryId: number
    recommendation: string
}

export interface IResumeLevelResource {
    userId: number
    resumeId: number
    resumeLevelId: number
    resumeLevel: string
    suggestion: {
        block: EProfileStrengthForm
        item: string
        value: number
        index: number
    }[]
    resumeStatus: string
    email: string
    messageInfo: string
    currentPoint: number
    totalPoint: number
    profileStrength: number
}
export interface IActivityRawData {
    data: {
        type: string
        id: number
        attributes: TActivityItemRawData
    }
}

export type TActivityItemRawData = {
    id: number
    activityId: number
    activity: string
    title: string
    organization: string
    fromDate: string
    toDate: string
    description: string
    isCurrent: number
    isNewActivity?: boolean
}

export interface IActivityResource {
    id: number
    activityId: number
    activity: string
    title: string
    organization: string
    fromDate: Date | null
    toDate: Date | null
    description: string
    isCurrent: boolean
    isNewActivity?: boolean
}

export interface IResumeLevelSuggestionResource {
    userId: number
    resumeId: number
    suggestion: {
        block: EProfileStrengthForm
        item: string
        value: number
        index: number
    }[]
}

export enum EProfileStrengthForm {
    CONTACT_INFO = 'ContactInfo',
    WORK_HISTORY = 'WorkingHistories',
    SKILLS = 'Skills',
    REFERENCES = 'References',
    WORKING_PREFERENCES = 'WorkingPreferences',
    BASIC_INFO = 'BasicInfo',
    SUMMARY = 'Summary',
    LANGUAGES = 'Languages',
    EDUCATIONS = 'Educations',
    RECOMMENDATION = 'Recommendation',
    PROJECTS = 'Projects'
}

export enum ESortableComponent {
    Reference = 'reference',
    WorkHistory = 'experience',
    Education = 'education',
    Activity = 'activity',
    Certification = 'certification',
    UserProjects = 'project'
}

export interface IAvatarResource {}

export interface ICertificationResource {
    certificationId: number
    certification: string
    organization?: string
    organizationId?: number
    organizationName?: string
    logo?: string
    fromDate: string
    linkCertification: string
}

export type TBasicInfoRawData = {
    data: {
        type: string
        id: number
        attributes: {
            avatar: string
            currentIndustries: []
            currentJobFunction: [] | null
            currentSalary: number
            firstName: string
            fullName: string
            highestDegreeId: number
            isDownload: boolean
            jobLevelId: number
            jobTitle: string
            lastCompany: string
            lastName: string
            newGraduate: boolean
            resumeId: number
            userId: number
            wowcvTemplateId: number
            yearsExperience: number
            isOpenToWork?: 0 | 1
            openToWorkExpiredOn?: string
        }
    }
}

export type TLanguageRawData = {
    data: {
        type: string
        id: number
        attributes: {
            language: number
            languageLevel: number
            resumeId: number
            userId: number
        }
    }[]
}

export type TSkillRawData = {
    data: {
        type: string
        id: number
        attributes: {
            skillLevel: number
            skillId: number
            skillName: string
            status: number
        }
    }[]
}

export enum EAttachmentResumeType {
    Default = 0,
    ViewApplied = 1,
    NewUpload = 2
}

export interface IAttachmentResumeParams {
    resumeId: number
    accessToken: string
}

export interface IActivityData {
    data: {
        type: string
        id: number
        attributes: {
            activity: string
            description: string
            fromDate: string
            isCurrent: number
            organization: string
            title: string
            toDate: string
        }
    }[]
}
